// SPF cart-drawer complementary nudge — "Add to complete your order".
// Document-delegated so it survives the cart drawer's morph re-renders, and
// dismiss persists via a <html> class (also morph-proof) + sessionStorage.
// Reuses the proven fly-to-cart + optimistic-count + cart:update sync pattern.
(function () {
  if (window.__spfCartNudge) return;
  window.__spfCartNudge = true;

  function isDismissed() {
    try { return sessionStorage.getItem('spfNudgeDismissed') === '1'; } catch (e) { return false; }
  }
  function applyDismiss() {
    if (isDismissed()) document.documentElement.classList.add('spf-nudge-off');
  }

  function flyToCart(imgEl) {
    try {
      if (!customElements.get('fly-to-cart')) return;
      var cartIcon = document.querySelector('.header-actions__cart-icon');
      if (!cartIcon || !imgEl) return;
      var src = imgEl.currentSrc || imgEl.getAttribute('src');
      if (!src) return;
      var fly = document.createElement('fly-to-cart');
      fly.classList.add('fly-to-cart--quick');
      fly.style.setProperty('background-image', 'url(' + src + ')');
      fly.style.setProperty('--start-opacity', '0');
      fly.source = imgEl;
      fly.destination = cartIcon;
      document.body.appendChild(fly);
    } catch (e) { /* non-fatal */ }
  }
  function bump(d) {
    document.querySelectorAll('cart-icon').forEach(function (i) {
      if (typeof i.beginOptimistic === 'function') i.beginOptimistic(d);
    });
  }
  // After an add, the cart drawer morphs (full re-render) and the scroll jumps
  // to the top — so the just-added item (appended at the BOTTOM) and the
  // refreshed suggestions scroll out of view, forcing the shopper back down.
  // Instead, keep the scroll pinned to the bottom of the item list so they stay
  // looking at the new suggestions (with the item they just added right above
  // them) and can keep one-tapping. The morph is async, so we re-pin on each
  // mutation for a short window plus a few timed fallbacks.
  function keepAtSuggestions() {
    var pin = function () {
      var items = document.querySelector('.cart-drawer__items');
      if (items) items.scrollTop = items.scrollHeight;
    };
    var obs;
    try {
      obs = new MutationObserver(pin);
      obs.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* no observer — timed fallbacks still run */ }
    [50, 150, 300, 550, 850].forEach(function (t) { setTimeout(pin, t); });
    setTimeout(function () { if (obs) obs.disconnect(); }, 1400);
  }

  // Refresh the cart everywhere — this is what makes the drawer morph (and the
  // nudge recompute: the just-added item drops out, a new pick may appear).
  // SPF fundraiser marker (task-fundraiser-program.md §5c): the $0 line is hidden in the
  // cart, so it must not be counted in the header badge either. The Liquid path already
  // excludes it (cart-bubble.liquid, and the ref="cartItemCount" span the cart component
  // reads); this broadcast is the one place a RAW /cart.js count reaches cart-icon.js, so
  // it has to agree or the badge reads one higher until the next page load. Handle, not
  // tag — /cart.js has no tags. Blank setting → unchanged count.
  function visibleItemCount(cart) {
    var el = document.querySelector('[data-spf-fundraiser-marker]');
    var handle = el && el.getAttribute('data-spf-fundraiser-marker');
    handle = handle ? handle.trim() : '';
    var n = (cart && cart.item_count) || 0;
    if (!handle) return n;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) n -= items[i].quantity;
    }
    return n < 0 ? 0 : n;
  }

  function sync() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var visible = visibleItemCount(cart);
        ['cart:update', 'cart:refresh', 'cart:updated', 'theme:cart:update'].forEach(function (n) {
          document.dispatchEvent(new CustomEvent(n, { detail: { resource: cart, cart: cart, data: { itemCount: visible } }, bubbles: true }));
        });
        document.querySelectorAll('[data-cart-count], .cart-count, .header-actions__cart-count').forEach(function (b) {
          b.textContent = String(visible);
        });
      }).catch(function () { /* silent */ });
  }

  document.addEventListener('click', function (e) {
    var dis = e.target.closest('[data-spf-nudge-dismiss]');
    if (dis) {
      try { sessionStorage.setItem('spfNudgeDismissed', '1'); } catch (e2) { /* ignore */ }
      document.documentElement.classList.add('spf-nudge-off');
      return;
    }
    var add = e.target.closest('[data-spf-nudge-add]');
    if (!add || add.disabled) return;
    var card = add.closest('.spf-nudge-card');
    var id = card && card.getAttribute('data-variant-id');
    if (!id) return;
    add.disabled = true;
    bump(1);
    var img = card.querySelector('.spf-nudge-thumb img');
    if (img) flyToCart(img);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error();
      if (window.SPFBeacon) window.SPFBeacon('drawer', 'add', id);
      sync();
      keepAtSuggestions();
    }).catch(function () { add.disabled = false; });
  });

  // Telemetry: one drawer-nudge impression per page view, counted only when the
  // nudge actually becomes visible (the drawer markup exists on every page but
  // sits inside a closed <dialog> until opened).
  function watchImpression() {
    var el = document.querySelector('.spf-nudge');
    if (!el || isDismissed() || !('IntersectionObserver' in window)) return;
    try {
      var seen = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (seen || !en.isIntersecting) return;
          seen = true;
          if (window.SPFBeacon) window.SPFBeacon('drawer', 'imp', null, el.querySelectorAll('.spf-nudge-card').length || 1);
          io.disconnect();
        });
      }, { threshold: 0.4 });
      io.observe(el);
    } catch (e) { /* telemetry only */ }
  }

  function init() {
    applyDismiss();
    watchImpression();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
